import { useState, Fragment } from 'react'
import CheckBox from 'components/CheckBox'
import Tooltip from 'components/Tooltip'

import {
  Container,
  Column,
  CheckRow,
  Label,
  Grid,
  HeaderCell,
  TimeCell,
  HeatCell
} from './styles'

const heatColors = [
  '#A3F3F3', // 0.0
  '#7FE2CE', // 0.1
  '#61E1A0', // 0.2
  '#91E15F', // 0.3
  '#D1E15F', // 0.4
  '#E8E15F', // 0.5
  '#F0C05F', // 0.6
  '#F0915F', // 0.7
  '#F05F5F', // 0.8
  '#F1464E'  // 0.9+
]

const weekDays = [
  'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'
]

function getAllTimes (heatmapData) {
  const timesSet = new Set ()

  Object.values (heatmapData).forEach (day => (
    Object.keys (day).forEach (time => timesSet.add (time))
  ))

  return Array.from (timesSet).sort ((a, b) => {
    const [ah, am] = a.split(':').map (Number)
    const [bh, bm] = b.split (':').map (Number)
    return ah !== bh ? ah - bh : am - bm
  })
}

function getHeatColor (value) {
  if (value === 0) return heatColors[0]
  const idx = Math.min (9, Math.floor (value * 10))
  return heatColors[idx]
}

export default function Heatmap ({ data: heatmapData }) {
  const { availableMap, occupiedMap, percentMap } = heatmapData
  const [valueDisplay, setValueDisplay] = useState ('percentage')
  const times = getAllTimes (availableMap)
  
  if (!heatmapData) return null

  return (
    <Container>
      <Column>
        <CheckRow>
          <CheckBox
            id='percentage'
            value={valueDisplay === 'percentage'}
            onValueChange={() => setValueDisplay ('percentage')}
          />
          <Label htmlFor='percentage'>
            Porcentagem de ocupação de horários
          </Label>
          <Tooltip
            id='percentage_tooltip'
            style={{marginTop: 2}}
            labelStyle={{width: 320}}
            message={
              'A porcentagem de ocupação de horários indica a proporção de horários ocupados'
              + ' por agendamentos em relação aos horários disponíveis (incluindo agendamentos cancelados).'
            }
          />
        </CheckRow>
        <CheckRow>
          <CheckBox
            id='values'
            value={valueDisplay === 'values'}
            onValueChange={() => setValueDisplay ('values')}
          />
          <Label htmlFor='values'>
            Agendamentos marcados / horários disponíveis
          </Label>
          <Tooltip
            id='values_tooltip'
            style={{marginTop: 2}}
            labelStyle={{width: 320}}
            message={
              'A quantidade de agendamentos marcados no horário em relação'
              + ' ao total de horários disponíveis (incluindo agendamentos cancelados).'
            }
          />
        </CheckRow>
      </Column>
      <Grid>
        <HeaderCell/>
        {weekDays.map ((day, i) => (
          <HeaderCell key={i}>{day}</HeaderCell>
        ))}
        {times.map (time => (
          <Fragment key={time}>
            <TimeCell>{time}</TimeCell>
            {weekDays.map ((_, idx) => {
              const dayIdx = (idx + 1).toString ()
              const percentValue = percentMap[dayIdx]?.[time] ?? 0
              const available = availableMap[dayIdx]?.[time] ?? 0
              const occupied = occupiedMap[dayIdx]?.[time] ?? 0
              const color = getHeatColor (percentValue)
              const percentLabel = percentValue > 0 ? Math.round (percentValue * 100) + '%' : ''
              const valuesLabel = available > 0 && occupied > 0 ? `${occupied} / ${available}` : ''

              return (
                <HeatCell
                  key={dayIdx + time}
                  color={color}
                  title={valueDisplay === 'percentage' ? percentLabel : valuesLabel}
                >
                  {valueDisplay === 'percentage' && percentLabel}
                  {valueDisplay === 'values' && available > 0 && occupied > 0 && valuesLabel}
                </HeatCell>
              )
            })}
          </Fragment>
        ))}
      </Grid>
    </Container>
  )
}
